/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { PropChallengeConditionsProfitSplit } from './prop-challenge-conditions-profit-split';

/**
 *
 * @export
 * @interface PropChallengeConditions
 */
export class PropChallengeConditions {
    /**
     *
     * @type {number}
     * @memberof PropChallengeConditions
     */
    profitTargetPercent: number;
    /**
     *
     * @type {number}
     * @memberof PropChallengeConditions
     */
    maxDailyLossPercent: number;
    /**
     *
     * @type {number}
     * @memberof PropChallengeConditions
     */
    maxOverallLossPercent: number;
    /**
     *
     * @type {PropChallengeConditionsProfitSplit}
     * @memberof PropChallengeConditions
     */
    profitSplit: PropChallengeConditionsProfitSplit;
    /**
     *
     * @type {number}
     * @memberof PropChallengeConditions
     */
    minimumDayTrading: number;
    /**
     *
     * @type {number}
     * @memberof PropChallengeConditions
     */
    timeLimitDays?: number;
    /**
     *
     * @type {number}
     * @memberof PropChallengeConditions
     */
    leverage?: number;
}
